import Qs from 'qs'
import omit from 'lodash/omit'
import { message as $message } from 'antd'
import { history } from 'umi'

import { getTerminaDomain } from '@/utils/utils'
import { getLocalTerminalDomain } from '@/utils/jump'

import { PARNER_MANAGE_SHOP_URL } from '@/modules/workweixin/constants'
import { DefaultQueryProps } from '@/modules/globals/hooks/usePageQuery'
import { GoodsImportModeEnum } from '@/components/ShopWidgets/ShopImportType'

import { getLoginCode } from '@/services/login'

/**
 * 行为参数
 */
export interface ActionQueryProps extends DefaultQueryProps {
    /**
     * @description     顶部tab显示浏览商家管理Tooltip
     */
    showVisitorManageGuide?: number
    /**
     * @description     打开推广小站弹框
     */
    isOpenPushModal?: number | boolean
    /**
     * @description     打开编辑名片抽屉
     */
    editCardInfo?: boolean
    /**
     * @description     打开合作说明弹框
     */
    isOpenSiteContactModel?: boolean
    /**
     * @description     打开的合作说明弹框中区分是否要和大店合作（和大店合作【处理分销商售后】默认勾选且不可取消）
     */
    isCoopWithBigShop?: boolean
    /**
     * @description     打开合作说明弹框且是和大店合作且定位到【处理分销商售后】
     */
    maintainAfterSalesInfo?: number
    /**
     * @description     打开【请选择创建商品的方式】的popup
     */
    createGoodsPop?: number
    /**
     * @description     打开【设置品牌控价】弹框
     */
    openControlPrice?: number
    /**
     * @description     打开【分销支付0费用】弹框
     */
    openOnlinePaymentFree?: number
    /**
     * @description     创建商品|导入供应商商品成功后查询结果的processId
     */
    processId?: string
    /**
     * @description     商品导入方式
     */
    importMode?: GoodsImportModeEnum
    /**
     * @description     供应商coId
     */
    supplierCoId?: string
    /**
     * @description     打开【设置库存同步】弹框
     */
    setStock?: number
    /**
     * @description     消息中心的来源key
     */
    source?: string
    /**
     * @description     erp分享商品的cacheId
     */
    erpCacheId?: string
    /**
     * @description     打开编辑联系方式弹框
     */
    editCard?: boolean
    /**
     * @description     打开【托管小站】弹框
     */
    autoShop?: boolean

    /** 滚动到 SPU 表格的最小起采件数列并高亮 */
    scrollToMinPurchaseQtyCol?: '1'

    /** 显示快递和运费配置弹窗 */
    showExpressConfig?: '1'
}

export const actionQuery: (keyof ActionQueryProps)[] = []

/**
 * 查询参数
 */

export type QueryProps = ActionQueryProps

/**
 *   @description 去我的分销小站
 */

export const goToMyPartnerShop = async (
    query: QueryProps & {
        /**
         * @description     是否需要新开浏览器页面
         */
        _blank?: boolean
        /**
         * @description     是否需要完整路径（比如op打开场景）
         */
        shouldFullPath?: boolean
        /**
         * @description   强制供应商侧
         */
        forceSupplierTerminal?: boolean
    },
) => {
    const queryObj = omit(query || {}, ['_blank', 'shouldFullPath', 'forceSupplierTerminal'])
    let paramsStr = Qs.stringify({ ...queryObj }, { addQueryPrefix: true })

    const { hostInfo } = window?.hostInstance?.getEnvInfo() || {}
    const isEmbeddedApp = hostInfo.isInErp || hostInfo.isInEpaas

    if (isEmbeddedApp) {
        paramsStr = Qs.stringify({ ...queryObj, ffrom: '' }, { addQueryPrefix: true })
        const url = `${getLocalTerminalDomain(
            window.PROJECT_CONFIG.supplierTerminalName,
        )}${PARNER_MANAGE_SHOP_URL}${paramsStr}`

        const { success, data, message } = await getLoginCode()
        if (success) {
            const newUrl = encodeURIComponent(url)
            const path = `${getLocalTerminalDomain(
                window.PROJECT_CONFIG.accountTerminalName,
            )}/jumpPage/index?simple_token=${data}&redirect=${newUrl}`

            window.open(path)
        } else {
            $message.error(message)
        }
    } else {
        if (query?.forceSupplierTerminal && !window.MASTER_IS_SUPPLIER) {
            const path = `${getTerminaDomain(
                window.PROJECT_CONFIG.supplierTerminalName,
            )}${PARNER_MANAGE_SHOP_URL}${paramsStr}`

            window.open(path, '_blank')
        } else {
            let path = `${PARNER_MANAGE_SHOP_URL}${paramsStr}`

            if (query?.shouldFullPath) {
                path = `${getTerminaDomain(
                    window.PROJECT_CONFIG.supplierTerminalName,
                )}${PARNER_MANAGE_SHOP_URL}${paramsStr}`
            }

            if (query?._blank) {
                window.open(path, '_blank')
            } else {
                history.push(path)
            }
        }
    }
}
